export default {
  disconnectUserFromGuiche: { method: "put", url: "guiche/disconnect" },
  findGuiches: { method: "get", url: "guiche" },
};
